import * as React from 'react';

const StopwatchSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="stopwatch_svg__eds-icon--stopwatch_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="stopwatch_svg__eds-icon--stopwatch_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.5 6V5h1c.8 0 1.5-.7 1.5-1.5S14.3 2 13.5 2h-3C9.7 2 9 2.7 9 3.5S9.7 5 10.5 5h1v1C7.3 6.3 4 9.8 4 14c0 4.4 3.6 8 8 8s8-3.6 8-8c0-4.2-3.3-7.7-7.5-8zm-2-2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3c.3 0 .5.2.5.5s-.2.5-.5.5h-3zM12 21c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"
        />
        <path
            id="stopwatch_svg__eds-icon--stopwatch_button"
            transform="rotate(-45.001 5.354 7.354)"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.9 6.9h2.8v1H3.9z"
        />
        <path
            id="stopwatch_svg__eds-icon--stopwatch_hand"
            transform="rotate(-45.001 14 12)"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.2 11.5h5.7v1h-5.7z"
        />
    </svg>
);

StopwatchSvg.displayName = 'StopwatchSvg';
export default StopwatchSvg;
